<template>
    <div>
        <v-data-table
                :headers="headers"
                :items="cantons"
                :loading="loading"
                :options.sync="options"
                :server-items-length="serverItemsLength"
                class="elevation-1"
                loading-text="Traženje..."
                :footer-props="{itemsPerPageText: 'Redaka po stranici:'}"
                :header-props="{sortByText: 'Poredaj po'}">
    
            <template v-for="header in headers.slice(0, headers.length - 1)" v-slot:[`item.${header.value}`]="{ item }">
                <div :key="header.value">
                    <a @click="readItem(item[header.value + '_route'], item[header.value + '_resourceId'])"
                       v-if="item[header.value + '_route']">
                        {{ item[header.value] }}
                    </a>
                    <span v-else style="color: black;">{{ item[header.value] }}</span>
                </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <td style="min-width: 200px">
                    <v-btn
                        color="primary mr-1"
                        x-small
                        min-height="30"
                        @click="openDialog(item)"
                    >
                        <v-icon class="pa-0" small>mdi-file</v-icon>
                    </v-btn>
                    <v-tooltip bottom v-for="(action, i) in headers[headers.length - 1].buttons"
                               :key="i">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs"
                                   v-on="on" class="mx-1" x-small min-height="30"
                                   :color="action.icon === 'mdi-delete' ? 'red' : 'primary'"
                                   @click="handleAction(action.callback, item)">
                                <v-icon
                                        ripple small class="pa-0" color="white"
                                >
                                    {{ action.icon }}
                                </v-icon>
                            </v-btn>
                        </template>
                        <span v-if="action.icon === 'mdi-pencil'">Uredi</span>
                        <span v-else-if="action.icon == 'mdi-delete'">Izbriši</span>
                    </v-tooltip>
                </td>
            </template>
    
            <template v-slot:no-data>
                <span>
                    Za tražene pojmove nema rezultata pretrage.
                </span>
            </template>
    
            <template v-slot:[`footer.page-text`]="items"> Prikazano {{ items.pageStart }} do {{ items.pageStop }} od ukupno
                {{ items.itemsLength }} rezultata
            </template>
        </v-data-table>

        <v-dialog
            v-model="dialog"
            width="600"
            @click:outside="closeDialog"
        >
            <v-card>
                <v-toolbar color="primary" dark class="elevation-0">
                    <v-toolbar-title>Dodajte predloške</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn @click.native="closeDialog" dark icon>
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-container class="pa-8">
                    <v-row>
                        <v-col cols="12" v-for="item in items" :key="item.name">
                          <v-autocomplete
                                outlined
                                dense
                                :items="item.source"
                                :name="item.name"
                                :prepend-icon="item.icon"
                                item-text="title"
                                item-value="id"
                                v-if="item.tag === 'select'"
                                v-model="form[item.name]"
                                :label="item.title"
                                hide-details
                            >
                            </v-autocomplete>
                            <v-text-field 
                                dense
                                :name="item.name"
                                outlined
                                hide-details
                                :label="item.title"
                                :prepend-icon="item.icon"
                                v-if="item.tag === 'input'"
                                v-model="form[item.name]"
                            >
                            </v-text-field>

                            <div v-if="item.tag === 'file'">
                              <span>{{item.title}}</span>
                                <vue-dropzone
                                    :options="dzSingle"
                                    :id="'dropZone_' + item.name"
                                    :name="item.name"
                                    ref="dropzone"
                                    @vdropzone-complete="(file) => onFileUpload(file, item)"
                                    style="margin-top: 5px;"
                                >
                                </vue-dropzone>
                            </div>
                        </v-col>
                        <v-col cols="12">
                            <v-btn
                                depressed
                                class="text-none"
                                color="primary"
                                height="44"
                                block
                                @click="addTemplate"
                            >
                                Dodaj predložak
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row class="mt-4">
                        <v-col>
                            <span>Predlošci koje ima županija</span>
                            <v-list v-if="currentCanton.document_templates">
                                <div
                                    class="d-flex justify-center text--disabled"
                                    v-if="currentCanton.document_templates.length === 0"
                                >
                                    Nema podataka
                                </div>
                                <div v-else>
                                    <v-list-item v-for="template in currentCanton.document_templates" :key="template.id" two-line>
                                        <v-list-item-avatar>
                                            <v-icon color="primary">
                                                mdi-file
                                            </v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ template.label }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                {{ template.template_type ? template.template_type.title : '' }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-icon @click="removeTemplate(template.id)">
                                                mdi-delete
                                            </v-icon>
                                        </v-list-item-action>
                                    </v-list-item>
                                </div>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {serverBus} from "@/main";
    import ApiV2 from '@/services/ApiV2'
    import VueDropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    export default {
        components: {
            VueDropzone
        },

        mounted: function () {
            this.getDataHeadersFromApi();
        },

        created() {
            if(localStorage.getItem('canton-options')){
                this.options = JSON.parse(localStorage.getItem('canton-options'));
                this.search = this.options.search
            }

            serverBus.$on('perform-search', (search_value) => {
                this.search = search_value;
            });

            serverBus.$on('filters-changed', (filters) => {
                this.options.filters = filters;
            });

            serverBus.$on('edit-item', (item) => {
                this.editItem(item);
            });

            serverBus.$on('delete-item', (item) => {
                this.deleteItem(item);
            });

            serverBus.$on(['reload-all-data', 'reload-table-data'], () => {
                this.search =  {
                    phrase: null,
                    field: null,
                }
                this.options.search = this.search
                serverBus.$emit('set-search', this.search)

                this.getDataFromApi();
            });
        },

        methods: {

            openDialog(canton) {
                this.currentCanton = canton;
                this.getTemplateTypes()
                this.dialog = true;
            },

            closeDialog() {
                this.dialog = false;
                this.form = {};
                this.$refs.dropzone[0].destroy();
              this.$refs.dropzone[1].destroy();
              this.$refs.dropzone[2].destroy();

            },

            async addTemplate() {
              this.form.model_type = 'Canton';
              this.form.model_id = this.currentCanton.id;
                let {data} = await ApiV2.post('document_templates', this.form)
              if (data){
                this.currentCanton.document_templates.push(data)
                this.closeDialog()
                serverBus.$emit('show-snackbar', true);
              }else{
                serverBus.$emit('show-snackbar', false);

              }

            },

            removeTemplate(templateId) {
                ApiV2.delete(`document_templates/${templateId}`).then(() => {
                        serverBus.$emit('show-snackbar', true);
                    }).catch(() => {
                        serverBus.$emit('show-snackbar', false);
                    })
            },

            onFileUpload(file, item) {
                if (file.accepted) {
                    if (item.tag === 'file') {
                        const response = file.xhr.response;
                        this.file = JSON.parse(response);
                        this.form[item.name] = this.file.id
                    }

                    serverBus.$emit('show-snackbar', true,);
                } else {
                    serverBus.$emit('show-snackbar', false);
                }
            },

            /* onFileRemove() {
                if(this.file.id) {
                    ApiV2.delete(`files/${this.file.id}`);
                }
            }, */


            getDataFromApi() {
                this.loading = true;

                ApiV2.get('cantons', {
                    params: {
                        ...this.options,
                        with: ['documentTemplates.templateType']
                    }
                }).then(response => {
                    this.cantons = response.data.data;
                    this.serverItemsLength = response.data.totalItems;

                    this.$store.commit('setData', this.cantons);
                }).finally(() => {
                    this.loading = false
                });

            },

          async getTemplateTypes(){
            let {data} = await ApiV2.get('template_types', {params: {perPage: -1}});
            this.items[0].source = data.data
          },

            getDataHeadersFromApi() {
                this.loading = true;

                this.$axios.post(this.$getTable() + '/zaglavlje').then(response => {
                    this.headers = response.data;

                    serverBus.$emit('headers-change', this.headers)
                     if(localStorage.getItem('canton-options')){
                        let search = JSON.parse(localStorage.getItem('canton-options')).search;
                        serverBus.$emit('set-search', search)
                    }
                }).finally(() => {
                    this.loading = false
                });
            },

            handleAction(action, item) {
                serverBus.$emit(action, item);
            },

            readItem(table, resourceId) {
                let resource = {id: resourceId};

                serverBus.$emit('show-add-edit-dialog', table, resource);
            },

            editItem(item) {
                serverBus.$emit('show-canton-add-form', item);
            },

            deleteItem(item) {
                serverBus.$emit('show-delete-item-dialog', this.$getTable(), item);
            },
        },

        watch: {
            options: {
                handler() {
                    this.options.search = this.search;
                    localStorage.setItem('canton-options', JSON.stringify(this.options));
                    this.getDataFromApi();
                },
                deep: true
            },

            search: {
                handler() {
                    if (this.search.field !== null && this.search.phrase !== null) {
                        let self = this;

                        self.loading = true;

                        clearTimeout(self.request);

                        self.request = null;
                        self.request = setTimeout(function () {
                            self.options.search = self.search;
                            localStorage.setItem('canton-options', JSON.stringify(self.options));
                            self.getDataFromApi();
                        }, 300);
                    }
                },
                deep: true
            },
        },

        beforeDestroy() {
            this.$destroyEvents();

            serverBus.$off('perform-search');
            serverBus.$off('filters-changed');
            serverBus.$off('edit-item');
            serverBus.$off('delete-item');
            serverBus.$off('reload-all-data');
            serverBus.$off('reload-table-data');
        },

        data: function () {
            return {
                cantons: [],
                headers: [],
                request: null,
                dialog: false,
                file: null,
                currentCanton: {},
                search: {
                    phrase: null,
                    field: null
                },
                options: {
                    filters: {},
                    itemsPerPage: 10,
                },
                loading: true,
                serverItemsLength: 0,
                form: {},
                dzSingle: {
                    url: process.env.VUE_APP_SKOLE_API_URL + 'v2/files',
                    method: 'POST',
                    params: {
                        folder: 'diplome-predlosci'
                    },
                    maxFilesize: 20,
                    maxFiles: 1,
                    dictDefaultMessage: 'Priložite predložak...',
                    withCredentials: true,
                    addRemoveLinks: true
                },
                items: [
                    {
                        data: "template_type_id",
                        name: 'template_type_id',
                        source: [],
                        rules: '',
                        tag: 'select',
                        title: 'Tip predloška',
                        type: 'select'
                    },
                             {
            data: "label",
            name: 'label',
            source: '',
            rules: '',
            tag: 'input',
            title: 'Naziv predloška',
            type: 'text'
          },

                  {
                    data: "male_file_id",
                    name: 'male_file_id',
                    options: '',
                    rules: '',
                    tag: 'file',
                    title: 'Predložak muški rod',
                    type: 'number'
                  },
                  {
                    data: "female_file_id",
                    name: 'female_file_id',
                    options: '',
                    rules: '',
                    tag: 'file',
                    title: 'Predložak ženski rod',
                    type: 'number'
                  },
                  {
                    data: "file_id",
                    name: 'file_id',
                    options: '',
                    rules: '',
                    tag: 'file',
                    title: 'Predložak neutralni',
                    type: 'number'
                  },
                ],
            }
        },

    }
</script>
